import axios from 'axios';
import * as environment from '../../../environment';
import { currentEnvironment, currentRegion } from '../../../helpers';

export interface PaypalExpressTokenArgs {
  orderTotal: number;
  currency: string;
  address: {
    name: string;
    line1: string;
    line2: string | undefined;
    city: string;
    state: string;
    country: string;
    postalCode: string;
  };
  returnUrl: string;
  cancelUrl: string;
}

export interface PaypalExpressTokenData {
  success: boolean;
  data: {
    data: {
      token: string;
    };
  };
}

export interface PaypalExpressTokenResponse {
  response: PaypalExpressTokenData | null;
  error: any;
}

export const paypalExpressTokenAxios = async (
  data: PaypalExpressTokenArgs
): Promise<PaypalExpressTokenResponse> => {
  const region = currentRegion();
  const application = currentEnvironment();

  const externalGateway = environment.envApolloUrls[application].external;

  let error = null;
  let response = null;

  try {
    response = (await axios.post(
      externalGateway + '/v1/paypal/express_checkout_tokens/generate',
      data,
      {
        headers: {
          'x-waldo-region': region,
        },
      }
    )) as PaypalExpressTokenData;
  } catch (errorResponse) {
    error = errorResponse;
  }

  return { response, error };
};
